<div>{{ "Selfservice.AuthenticationBoxTitle" | translate }}</div>
@if (auth.selfServiceStarted()) {
  <div class="green">
    {{ "Selfservice.AuthenticationBoxText" | translate }} {{ auth.selfServiceTokenExpiryTime() | twentyfourhourtime }}
  </div>
} @else {
  <div class="red">-</div>
}
